import { defineStore } from 'pinia'
import { ref, watch } from 'vue'

export const useSettingsStore = defineStore('settings', () => {
  const snowEnabled = ref(true)

  // Load from localStorage
  const storedSnow = localStorage.getItem('snowEnabled')
  if (storedSnow !== null) {
    snowEnabled.value = JSON.parse(storedSnow)
  }

  // Persist to localStorage
  watch(snowEnabled, (val) => {
    localStorage.setItem('snowEnabled', JSON.stringify(val))
  })

  const toggleSnow = () => {
    snowEnabled.value = !snowEnabled.value
  }

  return {
    snowEnabled,
    toggleSnow
  }
})
